import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af1425d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "device-info"
}
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "xag-ellipsis" }
const _hoisted_5 = { class: "sn" }
const _hoisted_6 = { class: "view-repair-info-wrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "查看报修信息", -1))

import { withDefaults } from 'vue'
import BlockkWrapper from '../block-wrap.vue'
import { MalfunctionRepairServiceOrderEquipmentItem } from '@/types/malfunction-repair'
import { useRouter } from 'vue-router'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import IconArrowRightWrap from '@/components/icon/IconArrowRightWrap.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'detail-device-block',
  props: {
    device: { default: () => null },
    sn: { default: '' },
    guid: null,
    is_uav: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { device: MalfunctionRepairServiceOrderEquipmentItem, sn: string, guid: string, is_uav: boolean };

const $router = useRouter()



const { addServiceOrderKeepAlive } = useMalfunctionRepairStore()
const toApplyInfo = () => {
  addServiceOrderKeepAlive()
  setTimeout(() => {
    $router.push({
      name: 'malfunction-repair-service-order-detail-apply-info',
      query: {
        guid: props.guid,
        is_uav: String(props.is_uav),
      },
    })
  }, 100)
}

function getInfoImageStyle(url: string) {
  return `background-image: url(${url})`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockkWrapper, {
    class: "product-info",
    title: "报修设备信息"
  }, {
    default: _withCtx(() => [
      (__props.device)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "img",
                style: _normalizeStyle(getInfoImageStyle(__props.device.logo))
              }, null, 4),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.device.name), 1),
                _createElementVNode("div", _hoisted_5, "SN：" + _toDisplayString(__props.sn) + "｜ " + _toDisplayString(__props.device.model_name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(IconArrowRightWrap, { onClick: toApplyInfo }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})